import React, {useEffect, useState} from 'react'
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import PaypalComponent from "../../paypal/PaypalComponent";
import {ProgressSpinner} from "primereact/progressspinner";
import DHDialog from "../../general/DHDialog";
import DHTextFieldSmall from "../../general/DHTextFieldSmall";
import DHButtonDefault from "../../general/DHButtonDefault";
import DHRadioGroup from "../../general/DHRadioGroup";
import DHCard from "../../general/DHCard";
import VeranstalterRechnungseinstellungenDialog from "./VeranstalterRechnungseinstellungenDialog";
import {SelectButton} from "primereact/selectbutton";
import DHProgress from "../../general/DHProgress";
import VeranstalterRechnungAnfordernButton from "./VeranstalterRechnungAnfordernButton";

export default function VeranstalterBezahlungDialog({eventOperatorId, onRefresh, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [typ, setTyp] = useState(undefined);
    const [zeitraum, setZeitraum] = useState("kostenlos");
    const [name, setName] = useState("");
    const [strasse, setStrasse] = useState("");
    const [pLZ, setPLZ] = useState("");
    const [ort, setOrt] = useState("");
    const [gutscheinCode, setGutscheinCode] = useState("");
    const [bezahlInfos, setBezahlInfos] = useState(undefined);
    const [priceDefault, setPriceDefault] = useState(undefined);
    const [priceSelected, setPriceSelected] = useState(undefined);
    const [gutscheinPrice, setGutscheinPrice] = useState(undefined);
    const [price, setPrice] = useState(undefined);
    const [price1Monat, setPrice1Monat] = useState(undefined);
    const [price3Monate, setPrice3Monate] = useState(undefined);
    const [price6Monate, setPrice6Monate] = useState(undefined);
    const [price12Monate, setPrice12Monate] = useState(undefined);
    const [refreshOnClose, setRefreshOnClose] = useState(false);

    const [showRechnungseinstellungen, setShowRechnungseinstellungen] = useState(false);


    useEffect(() => {
        ladePrice();
    }, []);

    useEffect(() => {
        ladeDaten();
    }, [eventOperatorId]);

    const ladeDaten = () => {
        if (eventOperatorId === null || eventOperatorId === undefined) {
            return;
        }
        let url = ConfigUtil.getConfig().resourceUrls.eventoperator + "/bezahlinfos/" + eventOperatorId;
        FetchUtil.fetchGet(url,
            json => {
                setBezahlInfos(json);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Daten: " + responseNotOk.message)
            },
            error => {
                setErrorMessage("Fehler beim Laden der Daten: " + error.message)
            });
    }

    const ladePrice = () => {
        let url = ConfigUtil.getConfig().resourceUrls.eventoperator + "/proaccount/price";
        FetchUtil.fetchGet(url,
            json => {
                setPrice(json.filter(tmp => tmp.typ === "12-monate")[0]);
                setPrice12Monate(json.filter(tmp => tmp.typ === "12-monate")[0]);
                setPrice6Monate(json.filter(tmp => tmp.typ === "6-monate")[0]);
                setPrice3Monate(json.filter(tmp => tmp.typ === "3-monate")[0]);
                setPrice1Monat(json.filter(tmp => tmp.typ === "1-monat")[0]);
                setPriceDefault(json);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Preis-Daten: " + responseNotOk.message)
            },
            error => {
                setErrorMessage("Fehler beim Laden der Preis-Daten: " + error.message)
            });
    }


    const testphaseEinloesen = () => {
        setErrorMessage(undefined);
        let url = ConfigUtil.getConfig().resourceUrls.eventoperator + "/testphase/" + eventOperatorId + "/" + gutscheinCode;
        FetchUtil.fetchPost(url,
            {},
            json => {
                setInfoMessage("Testphase wurde gespeichert.");
                ladeDaten();
                setGutscheinPrice(undefined);
                setGutscheinCode("");
                setRefreshOnClose(true);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Einlösen der Testphase: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Einlösen der Testphase: " + error.message)
            });
    }

    const gutscheinEinloesen = () => {
        setErrorMessage(undefined);
        let url = ConfigUtil.getConfig().resourceUrls.eventoperator + "/gutschein/" + gutscheinCode;
        FetchUtil.fetchPost(url,
            {},
            json => {
                setGutscheinPrice(json);
                setInfoMessage("Der Gutscheincode wurde akzeptiert. Preis wurde angepasst.")
                setRefreshOnClose(true);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Einlösen eines Gutscheins: " + responseNotOk.message);
                setGutscheinPrice(undefined);
            },
            error => {
                setErrorMessage("Fehler beim Einlösen eines Gutscheins: " + error.message)
                setGutscheinPrice(undefined);
            });
    }

    const getTestphaseArea = () => {
        return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
            {!gutscheinPrice.rechnungPerHand && !gutscheinPrice.gutschein && <>
                <div style={{marginBottom: 10}}>Du hast einen Gutscheincode eingelöst, der dich für eine Testphase in Darthelfer berechtigt.</div>
                <div style={{marginBottom: 10}}>Hinweis: Pro Veranstalter darf nur eine Testphase genutzt werden!</div>
            </>
            }
            <div style={{marginBottom: 10}}>
                <DHButtonDefault label={gutscheinPrice.rechnungPerHand || gutscheinPrice.gutschein ? "Gutschein einlösen" : "Testphase jetzt beginnen"}
                                 onClick={() => testphaseEinloesen()}/>
            </div>
        </div>
        }/>
    }

    const getRechnungArea = () => {
        if (bezahlInfos === null || bezahlInfos === undefined) {
            return "";
        }
        if (!bezahlInfos.kannWiederProVeranstalterBuchen) {
            return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
                <div>
                    Die aktuelle Veranstalter Pro-Zeit läuft noch. Du kannst erst 30 Tage vor Ablauf der Frist (ab dem {bezahlInfos.abWiederProVeranstalterBuchen}) wieder buchen.
                </div>
            </div>}/>
        }

        return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
            <div className="grid" style={{textAlign: "left"}}>
                <div className="col" style={{fontWeight: "bold"}}>
                    Weitere Veranstalter-Pro-Zeit, per Rechnung, buchen
                </div>
            </div>
            <div style={{marginTop:10, marginBottom:10}}>
                Die Rechnung wird über einen Preis in Höhe von {price12Monate.brutto} ausgestellt, dafür erhälst du einen Pro-Account über 12 Monate.
            </div>
            <div>
                <VeranstalterRechnungAnfordernButton
                    disabled={!bezahlInfos.rechnungsadresseVollstaendig}
                    eventOperatorId={eventOperatorId}
                    onRefresh={() => {
                        ladeDaten();
                        ladePrice();
                    }}
                    onError={(message) => setErrorMessage(message)}
                    onInfo={(message) => setInfoMessage(message)}/>
            </div>
        </div>}/>
    }


    const getPayPalArea = () => {
        if (bezahlInfos === null || bezahlInfos === undefined) {
            return "";
        }
        if (!bezahlInfos.kannWiederProVeranstalterBuchen) {
            return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
                <div>
                    Die aktuelle Veranstalter Pro-Zeit läuft noch. Du kannst erst 30 Tage vor Ablauf der Frist (ab dem {bezahlInfos.abWiederProVeranstalterBuchen}) wieder buchen.
                </div>
            </div>}/>
        }

        return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
            <div className="grid" style={{textAlign: "left"}}>
                <div className="col" style={{fontWeight: "bold"}}>
                    Weitere Veranstalter-Pro-Zeit, per PayPal, buchen
                </div>
            </div>
            {!bezahlInfos.kannWiederProVeranstalterBuchen && <>
                <div className="grid" style={{textAlign: "left"}}>
                    <div className="col">
                        Aktuell kannst du keine Bezahlung vornehmen. Vier Wochen vor Ablauf deiner Pro-Zeit ist die
                        Buchung wieder möglich.
                    </div>
                </div>
            </>}
            {getPayAreaProTimeSelection()}
            {bezahlInfos.rechnungsadresseVollstaendig && getPaypalButton()}
        </div>}/>
    }

    const getRechnungsadresse = () => {
        return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
            <div>
                <div>
                    <DHButtonDefault onClick={() => setShowRechnungseinstellungen(true)} label="Rechnungseinstellungen" disabled={false} />
                </div>
                <div style={{marginTop: 10, fontWeight:"bold"}}>
                    Folgende Daten werden auf der Rechnung angedruckt
                </div>
                <div style={{marginTop: 5}}>
                    Vereinsname / Rechnungsempfänger: {bezahlInfos.rechnungName}
                </div>
                <div style={{marginTop: 5}}>
                    Straße: {bezahlInfos.rechnungStrasse}
                </div>
                <div style={{marginTop: 5}}>
                    PLZ: {bezahlInfos.rechnungPlz}
                </div>
                <div style={{marginTop: 5}}>
                    Ort: {bezahlInfos.rechnungOrt}
                </div>
                <hr/>
                <div style={{marginTop: 10, fontWeight:"bold"}}>
                    Zusatzinfos zur Rechnung
                </div>
                <div style={{marginTop: 5}}>
                    Email: {bezahlInfos.rechnungEmail}
                </div>
                <div style={{marginTop: 5}}>
                    Automatische Rechnung: {bezahlInfos.rechnungAutomatisch ? "ja" : "nein"}
                </div>
                {!bezahlInfos.rechnungsadresseVollstaendig &&
                    <div style={{marginTop: 5, color:"red"}}>
                        Deine Daten für die Rechnung sind unvollständig, bitte überprüfen.
                    </div>
                }
            </div>
        </div>}/>
    }

    const getPayAreaProTimeSelection = () => {
        if (!bezahlInfos.kannWiederProVeranstalterBuchen) {
            return <div>Kann nicht buchen...</div>
        }
        let tmp12Monate = "1 Jahr Veranstalter Pro Account / " + price12Monate.brutto.replaceAll(".", ",") + ",- Euro";
        let tmp6Monate = "6 Monate Veranstalter Pro Account / " + price6Monate.brutto.replaceAll(".", ",") + ",- Euro";
        let tmp3Monate = "3 Monate Veranstalter Pro Account / " + price3Monate.brutto.replaceAll(".", ",") + ",- Euro";
        let tmp1Monat = "1 Monat Veranstalter Pro Account / " + price1Monat.brutto.replaceAll(".", ",") + ",- Euro";
        return <div>
            <DHRadioGroup id={"id-zeitraum"} label="Auswahl"
                          value={zeitraum} onChange={(value) => setZeitraum(value)}
                          model={[{label: "Kostenlos", value: "kostenlos"},
                              {label: tmp12Monate, value: "12-monate"},
                              {label: tmp6Monate, value: "6-monate"},
                              {label: tmp3Monate, value: "3-monate"},
                              {label: tmp1Monat, value: "1-monat"}]}/>
        </div>;
    }

    const getPaypalButton = () => {
        if (zeitraum === "kostenlos") {
            return "";
        }
        let tmpPrice = undefined;
        if( zeitraum === "12-monate") {
            tmpPrice = price12Monate;
        } else if( zeitraum === "6-monate") {
            tmpPrice = price6Monate;
        } else if( zeitraum === "3-monate") {
            tmpPrice = price3Monate;
        } else if( zeitraum === "1-monat") {
            tmpPrice = price1Monat;
        }

        return <PaypalComponent option={"event-operator"} price={tmpPrice.brutto}
                                data={{
                                    eventOperatorId: eventOperatorId,
                                    name: name,
                                    strasse: strasse,
                                    plz: pLZ,
                                    ort: ort,
                                    price: tmpPrice,
                                }}
                                onSuccess={
                                    () => {
                                        setInfoMessage("Zeitraum wurde gebucht!");
                                        ladeDaten();
                                        setRefreshOnClose(true);
                                    }
                                }
                                onResponseNotOK={
                                    (message) => setErrorMessage("Fehler: " + message)
                                }
                                onError={
                                    (message) => setErrorMessage("Fehler: " + message)
                                }
        ></PaypalComponent>
    }

    const getProAccountZeitraeume = () => {
        if (bezahlInfos === null || bezahlInfos === undefined) {
            return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
                <ProgressSpinner style={{width: 100, height: 100}}/>
            </div>}/>
        }
        if (bezahlInfos.zeitraeume === null || bezahlInfos.zeitraeume === undefined || bezahlInfos.zeitraeume.length === 0) {
            return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
                Keine Informationen über Veranstalter Pro-Account Zeiträume vorhanden.
            </div>}/>
        }

        let rows = [];
        const proEnde = bezahlInfos.zeitraeume[0];
        for (const zeitraum of bezahlInfos.zeitraeume) {
            rows.push(<div key={zeitraum.id}>
                <div>Zeitraum: {zeitraum.zeitraumvonString} - {zeitraum.zeitraumbisString}<br/>
                    Kaufzeitpunkt: {zeitraum.timestampString},
                    {zeitraum.hatRechnung && !zeitraum.storno && <>
                        <br/>
                        Rechnung: <a href={ConfigUtil.getConfig().resourceUrls.receipt + "/eventoperator/" + zeitraum.id}>herunterladen</a>
                    </>}
                    <br/>
                    Notiz: {zeitraum.notiz}
                    {zeitraum.hatRechnung && !zeitraum.bezahlt && !zeitraum.storno && <>
                        <br/>
                        <span style={{color:"red"}}>Diese Rechnung wurde, durch Darthelfer, noch nicht als bezahlt markiert.</span>
                    </>}
                    {zeitraum.storno && <>
                        <br/>
                        <span>--- Diese Rechnung wurde storniert. ---</span>
                    </>}
                </div>
                <hr/>
            </div>);
        }

        return <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
            <div style={{fontWeight: "bold", color: "green", marginBottom: 20}}>
                Dein aktueller Veranstalter Pro-Zeitraum endet am <span>{proEnde.zeitraumbisString}</span>
            </div>
            <h4>Informationen über deine Veranstalter Pro-Account Zeiträume.</h4>
            {rows}
        </div>}/>
    }

    const closeDialog = () => {
        if (refreshOnClose) {
            onRefresh();
        }
        onClose();
    }

    if (price12Monate === undefined || price12Monate === null) {
        return <DHDialog onClose={() => closeDialog()} title="Bezahlung" show={true} buttons={[]} showCloseButton={true}
                         comp={<div style={{fontSize: 18}}>
                             <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
                             <div>
                                 Wir laden Daten...
                             </div>
                         </div>}/>
    }

    if (eventOperatorId === null || eventOperatorId === undefined) {
        return <div style={{fontSize: 18}}>
            <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
            <div>
                Um eine Bezahlung vornehmen zu können, muss der Veranstalter inital gespeichert werden.<br/>Der aktuelle Jahrespreis für Darthelfer ist {price12Monate.brutto.replaceAll(".", ",")},- Euro.
            </div>
        </div>
    }

    if( bezahlInfos === undefined ) {
        return <DHDialog onClose={() => closeDialog()} title="Bezahlung" show={true} buttons={[]} showCloseButton={true}
                         comp={<div style={{fontSize: 18}}>
                             <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                                 onClearErrorMessage={() => setErrorMessage(undefined)}/>
                             <DHProgress size={20}/>
                         </div>
                         }
                         />

    }

    return <DHDialog onClose={() => closeDialog()} title="Bezahlung" show={true} buttons={[]} showCloseButton={true}
                     comp={<div style={{fontSize: 18}}>
                         <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                                             onClearErrorMessage={() => setErrorMessage(undefined)}/>
                         {showRechnungseinstellungen && <VeranstalterRechnungseinstellungenDialog
                             onClose={() => {
                                 setShowRechnungseinstellungen(false);
                                 ladeDaten();
                             }} eventOperatorId={eventOperatorId}/>}
                         <div>
                             <div style={{fontWeight: "bold", marginBottom: 5}}>Vergleich Versionen - kostenlos vs. Bezahlversion</div>
                             <div style={{marginBottom: 20}}><a href="https://support.darthelfer.de/viewtopic.php?t=101" target="_blank"
                                                                rel="noopener noreferrer">https://support.darthelfer.de/viewtopic.php?t=101</a></div>
                         </div>
                         <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
                             <div style={{marginBottom: 20, fontWeight: "bold"}}>Du bist hier im Bereich der Bezahlung für Veranstalter. Bezahle hier nur, sofern du Events über Darthelfer veranstalten
                                 möchtest.
                             </div>
                             <div style={{marginBottom:10}}>
                                 Wir bieten hier die Bezahlung über <span style={{fontWeight:"bold"}}>Rechnung</span> oder <span style={{fontWeight:"bold"}}>PayPal</span> an.
                             </div>
                             <div style={{marginBottom:10}}>
                                 Sofern du bezahlen möchtest, nutze bitte den Punkt 'Rechnungseinstellungen' um deine Rechnungsdaten zu erfassen.
                                 <br/>
                                 Wähle dann hier ob du per Rechnung (bevorzugt) oder per PayPal bezahlen möchtest.
                                 <br/>
                                 Achtung: Bei Bezahlung per Rechnung ist ausschließlich eine jährliche Zahlung möglich.
                                 <br/>
                                 Sofern du eine Rechnung anforderst oder per PayPal bezahlst, speichern wir dir umgehend den Pro-Account und du kannst sofort loslegen.<br/>
                                 Im Falle von Bezahlung per Rechnung zahle bitte umgehend (innerhalb von 7 Tagen). Wir deaktivieren deinen Veranstalter, wenn wir keinen Zahlungseingang innerhalb von 7 Tagen verbuchen können.
                             </div>
                             <div style={{marginBottom:10}}>
                                 Sobald du einmal erfolgreich an Darthelfer gezahlt hast, kannst du dir automatisch eine Rechnung, 14 Tage bevor der Pro-Account ausläuft, erzeugen lassen. Nehme die entsprechenden Einstellungen bitte unter dem Punkt 'Rechnungseinstellungen' vor.
                             </div>
                         </div>}/>
                         <DHCard text={<div style={{textAlign: "left", padding: 20, width: "100%", fontSize: 14}}>
                             <div style={{display: "flex", alignContent: "center", alignItems: "center"}}>
                                 <DHTextFieldSmall id="id-gutschein" label="Gutscheincode" value={gutscheinCode}
                                                   onChange={(text) => setGutscheinCode(text)} width={200}/>
                                 <DHButtonDefault onClick={() => gutscheinEinloesen()} label="Gutscheincode überprüfen"
                                                  disabled={gutscheinCode === "" || gutscheinCode.length < 10}/>
                             </div>
                         </div>}/>
                         {gutscheinPrice !== undefined && gutscheinPrice.testPhase && getTestphaseArea()}
                         {getProAccountZeitraeume()}
                         {getRechnungsadresse()}
                         <div style={{marginLeft:10, marginTop:20}}>
                             <SelectButton optionLabel="name" value={typ} options={  [{"name": "Rechnung", value: "rechnung"}, {"name": "PayPal", value: "paypal"}]} onChange={(e) => setTyp(e.value)}/>
                         </div>
                         {!price.testPhase && typ === "paypal" && getPayPalArea()}
                         {typ === "rechnung" && getRechnungArea()}
                     </div>}/>
}
